// extracted by mini-css-extract-plugin
export default {"container":"media-library_container__n7DsK","tabs":"media-library_tabs__F2-zV","mediaContainer":"media-library_mediaContainer__VZn7g"};